const language = {
    en : {
        search : "Search" ,
        gptSearch : "GPT Search" ,
        gptSearchPlaceholder : "What would you like to watch today?" ,
        signOut : "Sign Out" ,
        signIn : "Sign In" ,
        signUp : "Sign Up" ,
        nowPlaying : "Now Playing" ,
        popular : "Popular" ,
        topRated : "Top Rated" ,
        upcoming : "Upcoming" ,
        play: "Play" ,
        moreInfo : "More Info" ,
        home : "Home" ,
        namePlaceholder : "Name" ,
        emailPlaceholder : "Email or phone number" ,
        passwordPlaceholder : "Password" ,
        rememberMe : "Remember Me" ,
        alreadyRegistered : "Already registered ?" ,
        newToNetflix : "New to netflix ?" ,
        signInNow : "Sign in now" ,
        signUpNow : "Sign up now" ,
        needHelp : "Need Help ?"
    } ,
    hindi : {
        search : "खोज" ,
        gptSearch : "जीपीटी खोज" ,
        gptSearchPlaceholder : "आज आप क्या देखना चाहेंगे?" ,
        signOut : "साइन आउट" ,
        signIn : "साइन इन" ,
        signUp : "साइन अप" ,
        nowPlaying : "वर्तमान फिल्में" ,
        popular : "लोकप्रिय फिल्में" ,
        topRated : "टॉप रेटेड फिल्में" ,
        upcoming : "आने वाली फिल्में" ,
        play : "प्रारंभ करें" ,
        moreInfo : "और जानकारी" ,
        home : "घर" ,
        namePlaceholder : "नाम" ,
        emailPlaceholder : "ईमेल या फ़ोन नंबर" ,
        passwordPlaceholder : "पासवर्ड" ,
        rememberMe : "मुझे याद रखें" ,
        alreadyRegistered : "पहले से ही पंजीकृत ?" ,
        newToNetflix : "क्या आप नेटफ्लिक्स पर नए हैं ?" ,
        signInNow : "साइन इन करें" ,
        signUpNow : "साइन अप करें" ,
        needHelp : "मदद की ज़रूरत है ?" ,
    }
}

export default language;